import { FC, useCallback, useMemo, useState } from 'react';

import { useRecoilValue, useSetRecoilState } from 'recoil';

import { accountShopOrderList } from '@shared/api/shopOrder/shopOrder.controller';
import { shopOrderListForSellerByShopAccountUrl } from '@shared/api/shopOrder/shopOrder.hook';
import { ShopOrderForSellerAccount } from '@shared/api/shopOrder/shopOrder.interface';
import { Button } from '@shared/components/Button';
import { LoadingModal } from '@shared/components/LoadingModal';
import Modal from '@shared/components/Modal';
import {
  notificateError,
  notificateSuccess,
} from '@shared/plugIn/ant-notification/ant-notifiaction';
import { defaultApiMutationOptions } from '@shared/plugIn/apiMutation';
import { simpleOpenAtomFamily } from '@shared/state/atom';
import { notificationInstanceAtom } from '@shared/state/atom/notification.atom';
import { useAuth } from '@shared/state/hooks/useAuth';
import { formatDate } from '@shared/utils/formatDate';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

//* Admin이 해당 Seller에게 돈을 지급한 후 정산 버튼을 눌러 isAccounted true 및 auccountDate를 설정하기 위함

interface Props {
  shopOrderList: ShopOrderForSellerAccount[];
}

export const SellerAccountButton: FC<Props> = function SellerAccountButton({
  shopOrderList,
}: Props) {
  const openId = `sellerAccountButton-${formatDate(
    shopOrderList[0]?.paymentDetail.purchasedAt,
    {
      contains: {
        year: true,
        month: true,
      },
    },
  )}`;

  const { shopId } = useParams();
  const { sellerRole, isAdmin } = useAuth();
  const setOpen = useSetRecoilState(simpleOpenAtomFamily(openId));

  const notifiacationInstance = useRecoilValue(notificationInstanceAtom);
  const queryClient = useQueryClient();
  const { isLoading, mutate } = useMutation(defaultApiMutationOptions, {
    onSuccess: () => {
      notificateSuccess(notifiacationInstance, '정산 완료');
      queryClient.invalidateQueries(
        shopOrderListForSellerByShopAccountUrl(`${shopId}`, sellerRole()),
      );
    },
    onError: () => {
      notificateError(notifiacationInstance, '관리자계정 저장 실패');
    },
  });

  const [accountDate, setAccountDate] = useState<Date | null>(new Date());

  const onAccountClick = useCallback(async () => {
    const shopOrderListIdList = shopOrderList.map((shopOrder) => {
      return shopOrder._id;
    });
    try {
      if (shopOrderListIdList && accountDate) {
        const shopOrder = await accountShopOrderList(shopOrderListIdList, accountDate);
        console.log(shopOrder);
      }
    } catch (err: any) {
      console.error(err);
    }
  }, [shopOrderList, accountDate]);

  const isAccountComple = useMemo(() => {
    const notAccountedOrder = shopOrderList.find((order) => {
      return _.isNil(order.paymentDetail.isAccounted) || !order.paymentDetail.isAccounted;
    });

    if (notAccountedOrder) {
      return false;
    } else {
      return true;
    }
  }, [shopOrderList]);

  return (
    <>
      <Button
        onClick={() => {
          setOpen(true);
        }}
        disabled={!isAdmin() || isAccountComple}
        className={`shadow-sm  ${
          shopOrderList.length === 0
            ? 'cursor-default theme-text-7 theme-bg-8'
            : isAccountComple
            ? 'cursor-default bg-green-500 theme-text-4'
            : 'theme-text-4 theme-bg-main'
        } `}
      >
        {shopOrderList.length > 0
          ? isAccountComple
            ? '정산 완료'
            : '정산 처리'
          : '정산 없음'}
      </Button>
      <LoadingModal open={isLoading} title={'처리중'}></LoadingModal>
      <Modal openId={openId}>
        <div className="flex flex-col items-center gap-4">
          <div className="my-4">
            <p className="mb-2">정산 날짜 선택</p>
            <DatePicker
              onChange={(date) => setAccountDate(date ? date.toDate() : null)}
              defaultValue={accountDate ? dayjs(accountDate) : undefined}
            />
          </div>
          <Button
            onClick={() => {
              mutate(onAccountClick());
            }}
            className="theme-text-4 theme-bg-main"
          >
            확인
          </Button>
        </div>
      </Modal>
    </>
  );
};
